"use client";

import { c as _c } from "react/compiler-runtime";
import type { WaveGroupsConfig } from "@/types/waves.types";
import { CreateWaveGroupConfigType } from "@/types/waves.types";
import { CREATE_WAVE_NONE_GROUP_LABELS, CREATE_WAVE_SELECT_GROUP_LABELS } from "@/helpers/waves/waves.constants";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveToggle from "../utils/CreateWaveToggle";
import CreateWaveGroupSearchField from "./CreateWaveGroupSearchField";
export default function CreateWaveGroup(t0) {
  const $ = _c(23);
  const {
    waveType,
    groupType,
    chatEnabled,
    adminCanDeleteDrops,
    setChatEnabled,
    onGroupSelect,
    groupsCache,
    groups,
    setDropsAdminCanDelete
  } = t0;
  const getSelectedGroupId = () => {
    switch (groupType) {
      case CreateWaveGroupConfigType.ADMIN:
        {
          return groups.admin;
        }
      case CreateWaveGroupConfigType.CAN_VIEW:
        {
          return groups.canView;
        }
      case CreateWaveGroupConfigType.CAN_DROP:
        {
          return groups.canDrop;
        }
      case CreateWaveGroupConfigType.CAN_VOTE:
        {
          return groups.canVote;
        }
      case CreateWaveGroupConfigType.CAN_CHAT:
        {
          return groups.canChat;
        }
      default:
        {
          return null;
        }
    }
  };
  const selectedGroupId = getSelectedGroupId();
  const selectedGroup = selectedGroupId && groupsCache[selectedGroupId] ? groupsCache[selectedGroupId] : null;
  const isNotChatWave = waveType !== ApiWaveType.Chat;
  const inputDisabled = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && !chatEnabled;
  const defaultLabel = CREATE_WAVE_NONE_GROUP_LABELS[groupType];
  const t1 = CREATE_WAVE_SELECT_GROUP_LABELS[waveType][groupType];
  let t2;
  if ($[0] !== t1) {
    t2 = <h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-tracking-tight tw-text-iron-50 sm:tw-text-xl">{t1}</h3>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== chatEnabled || $[3] !== groupType || $[4] !== isNotChatWave || $[5] !== setChatEnabled) {
    t3 = isNotChatWave && groupType === CreateWaveGroupConfigType.CAN_CHAT && <CreateWaveToggle enabled={chatEnabled} onChange={setChatEnabled} label="Enable chat" displayLabel={true} />;
    $[2] = chatEnabled;
    $[3] = groupType;
    $[4] = isNotChatWave;
    $[5] = setChatEnabled;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== adminCanDeleteDrops || $[8] !== groupType || $[9] !== setDropsAdminCanDelete) {
    t4 = groupType === CreateWaveGroupConfigType.ADMIN && <CreateWaveToggle enabled={adminCanDeleteDrops} onChange={setDropsAdminCanDelete} label="Allow admins to delete posts" displayLabel={true} />;
    $[7] = adminCanDeleteDrops;
    $[8] = groupType;
    $[9] = setDropsAdminCanDelete;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">{t2}{t3}{t4}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== defaultLabel || $[16] !== inputDisabled || $[17] !== onGroupSelect || $[18] !== selectedGroup) {
    t6 = <CreateWaveGroupSearchField label={"Search groups\u2026"} defaultLabel={defaultLabel} disabled={inputDisabled} selectedGroup={selectedGroup} onSelect={onGroupSelect} />;
    $[15] = defaultLabel;
    $[16] = inputDisabled;
    $[17] = onGroupSelect;
    $[18] = selectedGroup;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-y-4">{t5}{t6}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}